export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5334.853d17e2.jpg";